import React from 'react';

import { Colors } from 'constants/Clementine';

export const ThemeContext = React.createContext({
  color: Colors.BLUE.hex,
  accent_color: Colors.GREEN.hex
});
